import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  aboutTitle: {
    id: "course-authoring.studio-home.sidebar.about.title",
    defaultMessage: "¿Eres nuevo en {studioName}?",
  },
  aboutDescription: {
    id: "course-authoring.studio-home.sidebar.about.description",
    defaultMessage:
    'Haz clic en "Buscar ayuda con Studio" en la parte inferior de la página para acceder a nuestra documentación actualizada continuamente y otros recursos de {studioShortName}.' 
 },
  studioHomeLinkToGettingStarted: {
    id: "course-authoring.studio-home.sidebar.about.getting-started",
    defaultMessage: "Comenzando con {studioName}",
  },
  sidebarHeader2: {
    id: "course-authoring.studio-home.sidebar.about.header-2",
    defaultMessage: "Can I create courses in {studioName}?",
  },
  sidebarDescription2: {
    id: "course-authoring.studio-home.sidebar.about.description-2",
    defaultMessage:
      "In order to create courses in {studioName}, you must {mailTo}",
  },
  sidebarDescription2MailTo: {
    id: "course-authoring.studio-home.sidebar.about.description-2.mail-to",
    defaultMessage: "contact {platformName} staff to help you create a course.",
  },
  sidebarHeader3: {
    id: "course-authoring.studio-home.sidebar.about.header-3",
    defaultMessage: "Can I create courses in {studioName}?",
  },
  sidebarDescription3: {
    id: "course-authoring.studio-home.sidebar.about.description-3",
    defaultMessage:
      "In order to create courses in {studioName}, you must have course creator privileges to create your own course.",
  },
  sidebarHeader4: {
    id: "course-authoring.studio-home.sidebar.about.header-4",
    defaultMessage: "Can I create courses in {studioName}?",
  },
  sidebarDescription4: {
    id: "course-authoring.studio-home.sidebar.about.description-4",
    defaultMessage:
      "Your request to author courses in {studioName} has been denied. Please {mailTo}.",
  },
  sidebarDescription4MailTo: {
    id: "course-authoring.studio-home.sidebar.about.description-4.mail-to",
    defaultMessage: "contact {platformName} staff with further questions",
  },
});

export default messages;
